module.exports = __webpack_public_path__ + "static/media/password.93c0fb00.svg";